import fetch from "../utils/fetch";
import JSEncrypt from "jsencrypt/bin/jsencrypt";
import { publicKey } from "../utils/secret";
import { getToken } from "../utils/token";
let encryptor = new JSEncrypt();
encryptor.setPublicKey(publicKey);
//登录
export const fetchLogin = (body) =>
  fetch(`login`, {
    method: "post",
    body,
  });

//刷新token
export const fetchRefreshToken = () =>
  fetch(`accessToken`, {
    method: "put",
    data: encryptor.encrypt(getToken()),
  });

//修改密码
export const editPassword = (body) =>
  fetch(`password`, {
    method: "put",
    body,
  });

//登出
export const logout = () =>
  fetch(`logout`, {
    method: "put",
  });

//获取七牛上传的token
export const fetchQiniuToken = () => fetch(`/upToken`);
